import { ISociedad } from '../../core/interfaces/societies.interface';

export class GetAllSocietiesAction {
  static readonly type = '[Societies] Get All';
  constructor() {}
}

export class AddSocietieAction {
  static readonly type = '[Societies] Add';
  constructor(public payload: ISociedad) {}
}

export class UpdatedSocietieAction {
  static readonly type = '[Societies] Updated';
  constructor(public payload: ISociedad) {}
}

export class DeleteSocietieAction {
  static readonly type = '[Societies] Delete';
  constructor(public payload: ISociedad) {}
}
